import { Button, Modal, ModalBody, ModalFooter, Text } from "@aurem/ui";
import { useInactivity } from "providers/ApolloClientProvider/InactivityProvider";
import { useI18n } from "providers/I18nProvider";
import { useSignOut } from "utils/auth";

export const InactivityDialog = () => {
  const { t } = useI18n();
  const { isVisible, setIsVisible } = useInactivity();
  const signOut = useSignOut();

  if (!isVisible) {
    return null;
  }

  return (
    <Modal
      open={isVisible}
      onOpenChange={setIsVisible}
      title={t("apps.admin.pages.inactive.title")}
      showClose={false}
      closeOnOutsidePress={false}
      className="outline-none"
    >
      <ModalBody>
        <Text as="p">{t("apps.admin.pages.inactive.subtext")}</Text>
      </ModalBody>
      <ModalFooter>
        <Button onClick={signOut}>{t("apps.admin.common.signOut")}</Button>
      </ModalFooter>
    </Modal>
  );
};
